<template>
    <v-form>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    md="4"
                >
                    <v-alert
                        ref="msg"
                        outlined
                        type="warning"
                        prominent
                        v-if="msg"
                        border="left"
                    >
                        {{ msg }}
                    </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    md="4"
                >
                    <v-select label="Name"
                              item-text="name"
                              :item-value="itemValueKey"
                              v-model="puid"
                              :items="users"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    md="4">
                    <v-date-picker
                        v-model="date"
                        :allowed-dates="allowedDates"
                        :first-day-of-week="1"
                        locale="de"
                        header-color="[ indigo  darken-2 ]"
                        color="cyan"
                        class="mt-4"
                    ></v-date-picker>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    md="4">
                    <v-text-field label="Vorspeise" v-model="starter"/>
                </v-col>
                <v-col
                    cols="12"
                    md="4">
                    <v-text-field label="Hauptspeise" v-model="main"/>
                </v-col>
                <v-col
                    cols="12"
                    md="4">
                    <v-text-field label="Nachspeise" v-model="dessert"/>
                </v-col>
            </v-row>
            <v-row class="text-center">
                <v-col>
                    <v-btn
                        large
                        color="cyan"
                        dark
                        :loading="isSending"
                        v-if="!success"
                        @click="submit"
                    >
                        Eintragen
                    </v-btn>
                    <v-btn
                        large
                        color="success"
                        dark
                        v-else
                    >
                        <v-icon>mdi-check</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
import moment from 'moment'
import UserService from '@/services/UserService';
import MealService from '@/services/MealService';
import PlanService from "@/services/PlanService";

moment.locale('de')

export default {
    name: 'Form',
    data() {
        return {
            date: null,
            isSending: false,
            success: false,
            dialog: false,
            users: [],
            puid: 0,
            itemValueKey: 'puid',
            starter: null,
            main: null,
            dessert: null,
            msg: null,
            userDates: []
        }
    },
    methods: {
        allowedDates(val) {
            const momentVal = moment(val)
            if (this.$store.getters.isAdmin && momentVal.weekday() < 5) {
                return val
            }
            if (this.userDates &&
                this.userDates.some(userDate => moment(userDate.date, 'DD.MM.YYYY').isSame(val, 'day')) &&
                momentVal.weekday() < 5
            ) {
                return val
            }
        },
        async submit() {
            this.isSending = true
            try {
                const formData = {
                    starter: this.starter,
                    main: this.main,
                    dessert: this.dessert,
                    puid: this.puid,
                    date: this.date ? moment(this.date).format('DD.MM.YYYY') : null,
                    week: moment(this.date).week()
                };
                const response = await MealService.submitMeal(formData)
                await this.pushMealToStore()
                this.msg = response.msg
                this.success = true
            } catch (error) {
                if (error.response) {
                    this.msg = error.response.data.msg
                    this.$nextTick(() => {
                        this.$refs.msg.$el.scrollIntoView({ behavior: 'smooth' })
                    })
                }
            }
            this.isSending = false
        },
        async pushMealToStore() {
            if (this.$store.getters.getSelectedYear === moment(this.date).year() &&
                this.$store.getters.getSelectedWeek === moment(this.date).week()) {
                // action?
                this.$store.commit('SET_MEALS', await MealService.getMeals(this.$store.getters.getSelectedWeek, this.$store.getters.getSelectedYear))
            }
        },
        async getUsers() {
            if (this.$store.getters.isAdmin) {
                this.users = await UserService.getPlanUsers()
                this.itemValueKey = 'id'
            } else {
                this.users = this.$store.getters.getUser.planUsers
                this.puid = this.$store.getters.getUser.planUsers[0].puid
            }
        },
        async getDatesForUser() {
            const currDate = this.date ? moment(this.date) : moment()
            const year =  currDate.format('YYYY')
            for (const planUser of this.$store.getters.getUser.planUsers) {
                const plans = await PlanService.getPlansUser(planUser.puid, year)
                this.userDates = this.userDates.concat(plans)
            }
        }
    },
    created() {
        this.getUsers()
        this.getDatesForUser()
    }
}
</script>
